import { UplinesList } from "./UplinesList";

export default UplinesList;
